 export enum TriListeElementVariableEnum {
NumeroContratCroissant = 0,
NumeroContratDecroissant = 1,
NomSalarieCroissant = 2,
NomSalarieDecroissant = 3,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/TriListeElementVariableEnum.ts